<div class="page-content dashboard">
  <!-- ── En-tête ──────────────────────────────────────────────────────── -->
  <div class="dash-header">
    <div>
      <h1 class="dash-title">Tableau de bord</h1>
      <p class="dash-subtitle">Bienvenue {{ username }}</p>
    </div>
  </div>

  <!-- ── KPI ──────────────────────────────────────────────────────────── -->
  <div class="dash-kpi-grid">
    <div class="dash-card dash-kpi" *ngFor="let k of kpis">
      <div class="dash-kpi__icon" [ngClass]="'tone-' + k.tone">
        <mat-icon>{{ k.icon }}</mat-icon>
      </div>
      <div class="dash-kpi__body">
        <p class="dash-kpi__title">{{ k.title }}</p>
        <p class="dash-kpi__value">{{ k.value }}</p>
      </div>
    </div>
  </div>

  <!-- ── Budget par poste ─────────────────────────────────────────────── -->
  <div class="dash-card dash-section">
    <div class="dash-section__header">
      <h3>Budget par type d'intervention</h3>
      <button
        *ngIf="errorStructures"
        class="dash-retry"
        (click)="retryStructures()"
      >
        <mat-icon>refresh</mat-icon> Réessayer
      </button>
    </div>

    <div class="dash-loader" *ngIf="isLoadingStructures">
      <mat-icon class="dash-spin">progress_activity</mat-icon> Chargement…
    </div>

    <div class="dash-error" *ngIf="!isLoadingStructures && errorStructures">
      <mat-icon>error_outline</mat-icon> {{ errorStructures }}
    </div>

    <div
      class="dash-empty"
      *ngIf="
        !isLoadingStructures &&
        !errorStructures &&
        budgetCategories.length === 0
      "
    >
      Aucune donnée budgétaire disponible.
    </div>

    <div
      class="dash-budget-list"
      *ngIf="
        !isLoadingStructures && !errorStructures && budgetCategories.length > 0
      "
    >
      <div class="dash-budget-row" *ngFor="let cat of budgetCategories">
        <div class="dash-budget-row__head">
          <span class="dash-budget-row__name">{{ cat.name }}</span>
          <span class="dash-budget-row__amount">
            {{ formatAmount(cat.spent) }} /
            {{ formatAmount(cat.allocated) }} XOF
          </span>
        </div>
        <div class="dash-progress">
          <div
            class="dash-progress__fill"
            [class.over]="budgetPercent(cat) >= 100"
            [style.width.%]="budgetPercent(cat)"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Interventions actives (projets) ─────────────────────────────── -->
  <div class="dash-card dash-section">
    <div class="dash-section__header">
      <h3>Interventions actives</h3>
      <button
        *ngIf="errorStructures"
        class="dash-retry"
        (click)="retryStructures()"
      >
        <mat-icon>refresh</mat-icon> Réessayer
      </button>
    </div>

    <div class="dash-loader" *ngIf="isLoadingStructures">
      <mat-icon class="dash-spin">progress_activity</mat-icon> Chargement…
    </div>

    <div
      class="dash-empty"
      *ngIf="
        !isLoadingStructures && !errorStructures && activeProjects.length === 0
      "
    >
      Aucune intervention avec des dates définies.
    </div>

    <div
      class="dash-projects"
      *ngIf="
        !isLoadingStructures && !errorStructures && activeProjects.length > 0
      "
    >
      <div class="dash-project-row" *ngFor="let p of activeProjects">
        <div class="dash-project-row__head">
          <span class="dash-project-row__name">{{ p.name }}</span>
          <span class="dash-project-row__meta"
            >{{ p.sousInterventionsCount }} sous-intervention(s)</span
          >
        </div>
        <div class="dash-progress dash-progress--sm">
          <div class="dash-progress__fill" [style.width.%]="p.progress"></div>
        </div>
        <div class="dash-project-row__footer">
          {{ p.progress }}% écoulé · {{ formatDate(p.dateDebut) }} →
          {{ formatDate(p.dateFin) }}
        </div>
      </div>
    </div>
  </div>

  <!-- ── Activités récentes ───────────────────────────────────────────── -->
  <!--  <div class="dash-card dash-section">
    <div class="dash-section__header">
      <h3>Activités récentes</h3>
      <button
        *ngIf="errorActivites"
        class="dash-retry"
        (click)="retryActivites()"
      >
        <mat-icon>refresh</mat-icon> Réessayer
      </button>
    </div>

    <div class="dash-loader" *ngIf="isLoadingActivites">
      <mat-icon class="dash-spin">progress_activity</mat-icon> Chargement…
    </div>

    <div class="dash-error" *ngIf="!isLoadingActivites && errorActivites">
      <mat-icon>error_outline</mat-icon> {{ errorActivites }}
    </div>

    <app-ui-table
      *ngIf="!isLoadingActivites && !errorActivites"
      [columns]="recentActivitesColumns"
      [data]="recentActivitesData"
      [pageSize]="6"
      [pageSizeOptions]="[6, 10, 25]"
      emptyMessage="Aucune activité récente"
    />
  </div> -->
</div>
